import React from 'react';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

function Sidebar({ activeView, setActiveView, onLogout, user, isAdmin }) {
  const { credits } = useAuth();
  return (
    <div className="sidebar">
      <div className="logo">
        <div className="logo-icon">
          <i className="fas fa-video"></i>
        </div>
        <div className="logo-text">XALENT</div>
      </div>

      <nav className="nav-menu">
        <div className="nav-section-label">Video Generation</div>
        <div
          className={`nav-item ${activeView === 'generate' ? 'active' : ''}`}
          onClick={() => setActiveView('generate')}
        >
          <i className="fas fa-magic"></i>
          <span>Generate Video</span>
        </div>

        <div
          className={`nav-item ${activeView === 'jobs' ? 'active' : ''}`}
          onClick={() => setActiveView('jobs')}
        >
          <i className="fas fa-list"></i>
          <span>All Jobs</span>
        </div>

        <div className="nav-divider"></div>
        <div className="nav-section-label">AI Influencer</div>

        <div
          className={`nav-item ${activeView === 'influencer-prompt' ? 'active' : ''}`}
          onClick={() => setActiveView('influencer-prompt')}
        >
          <i className="fas fa-film"></i>
          <span>Influencer Video</span>
        </div>

        <div
          className={`nav-item ${activeView === 'character-generator' ? 'active' : ''}`}
          onClick={() => setActiveView('character-generator')}
        >
          <i className="fas fa-user-plus"></i>
          <span>Build Character</span>
        </div>

        <div
          className={`nav-item ${activeView === 'character-library' ? 'active' : ''}`}
          onClick={() => setActiveView('character-library')}
        >
          <i className="fas fa-users"></i>
          <span>Character Library</span>
        </div>

        <div
          className={`nav-item ${activeView === 'environment-generator' ? 'active' : ''}`}
          onClick={() => setActiveView('environment-generator')}
        >
          <i className="fas fa-mountain"></i>
          <span>Build Environment</span>
        </div>

        <div
          className={`nav-item ${activeView === 'environment-library' ? 'active' : ''}`}
          onClick={() => setActiveView('environment-library')}
        >
          <i className="fas fa-images"></i>
          <span>Environment Library</span>
        </div>

        <div className="nav-divider"></div>

        {isAdmin && (
          <div
            className={`nav-item ${activeView === 'admin' ? 'active' : ''}`}
            onClick={() => setActiveView('admin')}
          >
            <i className="fas fa-shield-alt"></i>
            <span>Admin Panel</span>
          </div>
        )}

        <div
          className={`nav-item ${activeView === 'profile' ? 'active' : ''}`}
          onClick={() => setActiveView('profile')}
        >
          <i className="fas fa-user-circle"></i>
          <span>Profile</span>
        </div>

        <div className="nav-item">
          <i className="fas fa-cog"></i>
          <span>Settings</span>
        </div>

        <div className="nav-item">
          <i className="fas fa-question-circle"></i>
          <span>Help</span>
        </div>
      </nav>

      {user && (
        <div className="sidebar-user-info">
          <div className="sidebar-user-avatar">
            {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
          </div>
          <div className="sidebar-user-details">
            <span className="sidebar-user-name">{user.name}</span>
            <span className="sidebar-user-role">{user.role}</span>
          </div>
          {!isAdmin && (
            <div className="sidebar-credits-badge" title="Video credits remaining">
              <i className="fas fa-bolt"></i>
              <span>{credits}</span>
            </div>
          )}
        </div>
      )}

      <button className="xbtn xbtn-md xbtn-secondary logout-btn" onClick={onLogout}>
        <i className="fas fa-sign-out-alt"></i>
        Logout
      </button>
    </div>
  );
}

export default Sidebar;
